module.exports = __webpack_public_path__ + "static/media/grown.d8e9c1c4.jpg";